import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ConstructionIcon from '@mui/icons-material/Construction';

function Gyujtemenyek() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Button 
        startIcon={<ArrowBackIcon />} 
        onClick={() => navigate(-1)}
        sx={{ mb: 3 }}
      >
        Vissza
      </Button>
      
      <Box sx={{ 
        textAlign: 'center', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh'
      }}>
        <ConstructionIcon color="primary" sx={{ fontSize: 100, mb: 4 }} />
        <Typography variant="h2" component="h1" gutterBottom color="primary">
          Gyűjtemények
        </Typography>
        <Typography variant="h5" color="text.secondary">
          Ez a szekció fejlesztés alatt áll...
        </Typography>
      </Box>
    </Container>
  );
}

export default Gyujtemenyek;
